import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/fence-deck-leads-colorado")!;

export const Route = createFileRoute("/learn/fence-deck-leads-colorado")({
  head: () => seoHead("/learn/fence-deck-leads-colorado", "How Colorado Fence & Deck Builders Get More Quotes", "Material pages, HOA help, Google Maps, and reviews that bring Colorado fence and deck builders more quote requests.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
